import React, { useState, useEffect } from 'react';
import { ConvenienceFeeSettings } from '@projectK/modules/General/ConvenienceFee';
import jwtAxios from '@projectK/services/auth/JWT';
import { Box } from '@mui/material';

const FeeSettings = () => {
  const [settings, setBasicSettings] = useState(null);

  const fetchSettings = async () => {
    try {
      const response = await jwtAxios.get(`/app-settings/`);
      setBasicSettings(response.data);
    } catch (error) {
      // Handle error
      console.error('Error fetching appearance settings:', error);
    }
  };
  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <Box>
      {settings ? (
        <ConvenienceFeeSettings
          defaultSettings={settings}
          fetchSettings={fetchSettings}
        />
      ) : (
        <p>Loading location settings...</p>
      )}
    </Box>
  );
};

export default FeeSettings;
